import React from "react";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

export default function LegalbirdAuthenticatedLoaderPage() {
  return (
    <LayoutProtectedRoutes>
      <LegalbirdLoader />
    </LayoutProtectedRoutes>
  );
}
